module.exports = __webpack_public_path__ + "static/media/linkdin.19d6c638.svg";